/** Serialize store replacement after the previous persistor finishes its writes. */
export function createPersistedReinitializer(initialize, getPersistor) {
  let pending = Promise.resolve();
  return () => {
    const current = pending
      .catch(() => {})
      .then(async () => {
        const persistor = getPersistor();
        if (persistor) {
          persistor.pause();
          await persistor.flush();
        }
        await initialize();
      });
    pending = current;
    return current;
  };
}
